<template>
  <PageContainer>
    <template v-slot:body>
      <Container>
        <Card
          v-if="!loading"
          :noBorder="true"
        >
          <PlanInformation />
          <RecommendedPackageBadge
            v-if="hasRecommendations"
            :recommendedAddOns="recommendedAddOns"
            :recommendedPackage="recommendedPackage"
          />
        </Card>
        <Card
          v-if="showBillingSummary"
          :class="$style.billingSummary"
          :noBorder="true"
        >
          <BillingSummary />
        </Card>
        <LoadingOverlay :visible="loading" />
      </Container>
    </template>
  </PageContainer>
</template>

<script>
import {
  Card,
  Container,
  LoadingOverlay,
  PageContainer,
} from '@jumpcloud/ui-components';

import {
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapActions, mapGetters, mapState } from 'vuex';
import { notify } from 'client/util';
import BillingSummary from 'client/Account/OverviewPage/BillingSummary';
import PlanInformation from 'client/Account/OverviewPage/PlanInformation';
import RecommendedPackageBadge from 'client/components/Badges/RecommendedPackageBadge';

const settingsModule = StoreModuleMap[ItemTypeConsts.settings];
const subscriptionCollection = StoreModuleMap[ItemTypeConsts.subscription];
const planProductCodeIsDevices = 'DEVICES';
const recommendationModule = 'RecommendationModule';
const planModule = 'PlanModule';

export default {
  name: 'OverviewPage',

  components: {
    BillingSummary,
    Card,
    Container,
    LoadingOverlay,
    PageContainer,
    PlanInformation,
    RecommendedPackageBadge,
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapGetters(recommendationModule, [
      'hasRecommendations',
    ]),

    ...mapState(settingsModule, [
      'isCustomer',
    ]),

    ...mapState(planModule, [
      'plan',
    ]),

    ...mapState(recommendationModule, [
      'recommendedPackage',
      'recommendedAddOns',
    ]),

    ...mapGetters(subscriptionCollection, {
      activeSubscriptions: 'getCollection',
    }),

    showBillingSummary() {
      return this.isCustomer
        && !!this.plan.contractType
        && !this.loading
        && this.plan.productCode !== planProductCodeIsDevices;
    },
  },

  created() {
    this.loadingAddOns = true;
    this.loading = true;

    Promise.allSettled([
      this.fetchAddOns(),
      this.fetchPlan(),
      this.fetchRecommendations(),
    ])
      .then(([addOnResponse, planResponse, recommendationResponse]) => {
        this.manageResponse(addOnResponse, 'Unable to fetch add-on list');
        this.manageResponse(planResponse, 'Unable to fetch plan');
        this.manageResponse(recommendationResponse, 'Unable to fetch recommendations');

        if (!this.activeSubscriptions.length) {
          return this.fetchSubscriptions();
        }

        return null;
      })
      .catch(() => {
        notify('error', 'Unable to fetch subscriptions');
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    ...mapActions('AddOnCollection', {
      fetchAddOns: 'fetchCollection',
    }),

    ...mapActions('RecommendationModule', ['fetchRecommendations']),

    ...mapActions('PlanModule', ['fetchPlan']),

    ...mapActions(subscriptionCollection, {
      fetchSubscriptions: 'fetchCollection',
    }),

    manageResponse(response, error) {
      if (response.status === 'rejected') notify('error', error);
    },
  },
};
</script>

<style module>
.billingSummary {
  margin-top: var(--jc-spacer-medium);
}
</style>
